import React, { Component } from 'react';

import '../styles/close-btn.css';

class CloseBtn extends Component {
  render() {
    const { callback } = this.props;

    return <div className="close-btn-container cursor-pointer" onClick={callback} />;
  }
}

export default CloseBtn;



// WEBPACK FOOTER //
// ./src/app/shared/close-btn/components/close-btn.js